import { EnvironmentMapping } from '@/constants/env.constant'
import { TimeStandard, TimezoneOffset, TimezoneOffsetText } from './constants'
import type { LocaleConfig } from './type'
import { AppEnvironment } from '@/constants/app.constant'

enum TimezoneVN {
  HOCHIMINH = 'Asia/Ho_Chi_Minh',
}

const HELPER_CENTER_URL = `https://help.cs.${
  EnvironmentMapping[AppEnvironment.current]
}shopeefood.vn/portal?source=103`

const localeConfig: LocaleConfig = {
  helpCenterUrl: HELPER_CENTER_URL,
  /**
   * timezone
   */
  defaultTimezone: TimezoneVN.HOCHIMINH,
  getTimezone: (timezone?: string) => {
    const lowerTimezone = timezone?.toLowerCase()
    const config = {
      [TimezoneVN.HOCHIMINH.toLowerCase()]: {
        timezoneStandardText: TimeStandard.UTC,
        timezoneOffset: TimezoneOffset.UTC7,
        timezoneOffsetText: TimezoneOffsetText[TimezoneOffset.UTC7],
        timezoneName: TimezoneVN.HOCHIMINH,
      },
    }
    return config[lowerTimezone as TimezoneVN] || config[TimezoneVN.HOCHIMINH.toLowerCase()]
  },

  currency: {
    CODE: 'VND',
    LOCALES: 'vi-VN',
    SYMBOL: '₫',
    MIN_FRACTION_DIGITS: 0,
    MAX_FRACTION_DIGITS: 5,
    SUFFIX_SYMBOL: true,
  },

  policyUrl: 'https://shopeefood.vn/regulation-web',

  wallet: {
    availableBalanceReachAmount: 'no limit', // VN 的最低可提现金额没有限制，仅为了统一
  },

  price: {
    regExp: /^(\d+)(\.\d{0,2})?$/,
    precision: 2,
  },

  requirementUrl:
    'https://merchant.shopeefood.vn/edu/article/huong-dan-cap-nhat-thuc-don-hang-loat-tren-trang-web-shopee-partner',

  menu: {
    dish: {
      maxNameLength: 255,
      minPrice: 1,
      maxPrice: 10000000,
      maxBindingOptionGroup: 20,
      maxDescriptionLength: 250,
      priceChangeRules: [{ threshold: Infinity, increasePercent: 100 }],
    },

    option: {
      minPrice: 0,
      maxPrice: 10000000,
      maxNameLength: 70,
      priceChangeRules: [{ threshold: Infinity, increasePercent: 100 }],
    },

    optionGroup: {
      linkDishLimit: 500,
      maxNameLength: 80,
    },
  },

  order: {
    history: {
      maxDateRange: 90,
      maxDateRangeSelecting: 30,
      defaultDateRangeSelecting: 30,
      maxStoreIds: Number.MAX_SAFE_INTEGER,
    },
  },

  assistanceContactNumber: '1500702',
}

export default localeConfig
